export default "__VITE_ASSET__CfsUR4mS__"